import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { getTicketRequestCategories } from 'api/ticketRequestCategories';
import { RequestQueryKeysE, RequestStaleTimeE } from 'declarations/enums/react-query';
import type { ApiErrorI } from 'declarations/interfaces/errors';
import type { TicketRequestCategoryI } from 'declarations/interfaces/ticketRequestCategories';

export const useFetchTicketRequestCategories = (
  isEnabled: boolean,
  roofTopId?: string
): UseQueryResult<TicketRequestCategoryI[], ApiErrorI> => {
  return useQuery<TicketRequestCategoryI[], ApiErrorI>(
    [RequestQueryKeysE.FetchTicketRequestCategories, roofTopId],
    () => getTicketRequestCategories(roofTopId),
    {
      enabled: isEnabled && !!roofTopId,
      staleTime: RequestStaleTimeE.TicketRequestCategories,
    }
  );
};
